module.exports = __webpack_public_path__ + "img/ic_share_fb.177c4cc8.svg";